import store from "@/store";

export default {
  install: (Vue: any) => {
    Object.defineProperty(Vue.prototype, "$userCan", {
      value: store.getters["user/can"]
    });
  }
};
